<template #content>
    <Dialog
        ref="contratoDialog"
        :visible="visible"
        @update:visible="updateVisible"
        @show="onShow"
        @hide="onHide"
        class="w-11 lg:w-8"
        modal >
        <template #header>
            <div class="flex justify-content-between flex-wrap w-full">
                <div>
                    <span class="font-bold">Contrato</span>
                </div>

                <div class="flex justify-content-end gap-1">
                    <Button
                        v-if="form.id"
                        label="Log"
                        severity="secondary"
                        icon="pi pi-history"
                        size="small"
                        class="flex align-items-center justify-content-center"
                        @click="openLogForm"
                        :loading="isLoading" />
                </div>
            </div>
        </template>
        
        <form @submit.prevent="onSubmit(form)">
            <Tabs class="contrato-tab-principal" v-model:value="tabIndex" @update:value="fixScrollPanelBarsAccessibility">
                <TabList>
                    <Tab :value="0">
                        Contrato
                    </Tab>
                    <Tab :value="1">
                        Financeiro 
                    </Tab>                    
                    <Tab :value="2" :disabled="!form.id">
                        Contas
                    </Tab>
                </TabList>
                <TabPanels>
                    <TabPanel :value="0">
                        <ScrollPanel style="height: 65vh">
                            <FormTabResumoDados :form="form" :errors="errors" :can-edit-observacoes="canEditObservacoes" />
                        </ScrollPanel>
                    </TabPanel>
                    <TabPanel :value="1">
                        <ScrollPanel style="height: 65vh">
                            <FormTabResumoFinanceiro :form="form" :errors="errors" :permissoes="permissoes" />
                        </ScrollPanel>
                    </TabPanel>
                    <TabPanel :value="2">
                        <ScrollPanel style="height: 65vh">
                            <FormTabResumoContas
                                v-if="form.id"
                                :contrato="form"
                                :permissoes="permissoes"
                                :financeiro-preenchido="financeiroPreenchidoCorretamente"
                                @onOpenContaForm="openContaForm" />
                        </ScrollPanel>
                    </TabPanel> 
                </TabPanels>
            </Tabs>

            <div class="flex justify-content-between flex-wrap">
                <div class="flex justify-content-start flex-wrap gap-1">
                    <div class="text-xs">
                        <span class="text-red-500">*</span> obrigatório<br>
                    </div>
                </div>

                <div class="flex justify-content-end gap-1">
                    <Button
                        :disabled="!canSubmit"
                        type="button"
                        label="Salvar"
                        severity="success"
                        icon="pi pi-save"
                        size="small"
                        class="flex align-items-center justify-content-center"
                        :loading="isLoading"
                        @click="onSubmit(form)" />
                    <Button
                        label="Fechar"
                        severity="warn"
                        icon="pi pi-times"
                        size="small"
                        @click="updateVisible(false)"
                        class="flex align-items-center justify-content-center"
                        :loading="isLoading" />
                </div>
            </div>
        </form>
        
        <LogForm :visible="visibleLogForm" table="contratos" :tableId="form.id" @close="this.visibleLogForm=false" />
    </Dialog>
</template>
<script>
import Dialog from 'primevue/dialog';
import Button from 'primevue/button';
import Tabs from 'primevue/tabs';
import TabList from 'primevue/tablist';
import Tab from 'primevue/tab';
import TabPanels from 'primevue/tabpanels';
import TabPanel from 'primevue/tabpanel';
import ScrollPanel from 'primevue/scrollpanel';

import Contrato from '@/service/contrato.js';
import ContratoConta from '@/service/contratoConta.js';

import FormTabResumoDados from '@/page/contrato/tabsResumo/FormTabResumoDados.vue';
import FormTabResumoContas from '@/page/contrato/tabsResumo/FormTabResumoContas.vue';
import FormTabResumoFinanceiro from '@/page/contrato/tabsResumo/FormTabResumoFinanceiro.vue';

import LogForm from '@/components/LogForm.vue';

export default {
    components: { Dialog,
                  Button,
                  Tabs,
                  TabList,
                  Tab,
                  TabPanels,
                  TabPanel,
                  ScrollPanel,

                  FormTabResumoDados,
                  FormTabResumoFinanceiro,
                  FormTabResumoContas,
                  LogForm,
                },
    props: {
        id: {
            type: Number,
            default: 0
        },
        visible: {
            type: Boolean,
            default: false
        },
        data: {
            type: Object,
            default: {}
        },
        permissoes: {},
        initialTab: {
            type: Number,
            default: 0,
        },
    },
    emits: ['save','close', 'onOpenContaForm'],
    data() {
        return {
            form: {},
            errors: {},
            isLoading: false,
            visibleLogForm: false,
            tabIndex: this.initialTab || 0,
        }
    },
    watch: {
        visible(newValue) {
            if (newValue) {
                this.tabIndex = this.initialTab || 0;
            }
        },
    },
    computed: {
        canEditObservacoes() {
            return !!((this.permissoes || {}).CONTRATO_EDITAR);
        },
        canSubmit() {
            if (!this.form.id) {
                return false;
            }
            if (this.tabIndex == 0) {
                return this.canEditObservacoes;
            }
            if (this.tabIndex == 1) {
                return true;
            }
            return false;
        },
        financeiroPreenchidoCorretamente() {
            const f = this.form;
            if (!f) {
                return false;
            }
            // Mesma regra do badge "P" em Contratos Vigentes: sem linha em contratos_contas não há financeiro persistido.
            if (f.contrato_id == null || f.contrato_id === '') {
                return false;
            }
            if (!this.dataPrimeiroPagamentoValida(f.data_primeiro_pagamento)) {
                return false;
            }
            const dia = Number(f.dia_pagamento);
            if (!Number.isFinite(dia) || dia < 1 || dia > 31) {
                return false;
            }
            const valor = Number(f.valor_inicial);
            if (!Number.isFinite(valor) || valor <= 0) {
                return false;
            }
            return true;
        },
    },
    methods: {
        dataPrimeiroPagamentoValida(valor) {
            if (valor == null || valor === '') {
                return false;
            }
            const d = valor instanceof Date ? valor : new Date(valor);
            return !Number.isNaN(d.getTime());
        },
        openContaForm(conta) {
            this.$emit('onOpenContaForm', conta);
        },
        onShow() {
            this.tabIndex = this.initialTab || 0;
            if(this.id) {
                this.loadContrato();
                return;
            }
            this.form = Contrato.parse({...this.data});
            this.fixScrollPanelBarsAccessibility();
        },
        onHide() {
            this.tabIndex = this.initialTab || 0;
            this.form = {};
        },
        openLogForm() {
            this.visibleLogForm = true;
        },
        loadForm(form) {
            if (!form) {
                // O backend pode retornar data:null quando o contrato não casa com o filtro de "vigente" (etapa != CONCLUIDO).
                // Nesse caso preservamos o form atual; o save já foi feito, o componente já vai fechar via $emit('close').
                return;
            }
            this.form = Contrato.parse(form);
        },
        updateVisible(visible) {
            this.$emit('close', visible);
        },
        fixScrollPanelBarsAccessibility() {
            this.$nextTick(() => {
                const root = this.$refs.contratoDialog?.$el;
                if (!root?.querySelectorAll) {
                    return;
                }
                root.querySelectorAll('.p-scrollpanel-bar[tabindex="0"]').forEach((bar) => {
                    bar.setAttribute('tabindex', '-1');
                });
            });
        },
        loadContrato() {
            this.isLoading = true;
            Contrato.get(this.id)
                .then(response => {
                    this.loadForm(response.data);
                })
                .finally(() => {
                    this.isLoading = false;
                    this.fixScrollPanelBarsAccessibility();
                });
        },
        onSubmit(form) {
            this.errors = {};

            let request = null;
            if (this.tabIndex == 0) {
                request = Contrato.updateObservacoes(form.id, {
                    observacoes: form.observacoes,
                });
            }
            if (this.tabIndex == 1) {
                request = ContratoConta.update(form.id, form);
            }
            if (!request) {
                return;
            }

            this.isLoading = true;
            request
                .then(response => {
                    this.$toast.add({ severity: 'success', summary: 'Sucesso', detail: 'Seus dados foram salvos com sucesso.', life: 3000 });

                    this.loadForm(response.data.data);

                    // Emite o form salvo como payload para consumidores que precisam dos valores recém persistidos.
                    // Ex: FrenteFinanceiroOperador usa valor_inicial + data_primeiro_pagamento pra sugerir ao ContaForm.
                    this.$emit('save', this.form);
                    this.$emit('close');
                })
                .catch(error => {
                    if(error.response) {
                        let err = error.response.data;
                        
                        if(err.erros && typeof err.erros === 'object') {
                            for(let i in err.erros) {
                                this.errors[i] = err.erros[i][0];
                            }
                            if(err.msg) {
                                this.$toast.add({ severity: 'error', summary: 'Ops!', detail: err.msg, life: 5000 });
                            }
                            return;
                        }
                        if(err.msg) {
                            this.$toast.add({ severity: 'error', summary: 'Ops!', detail: err.msg, life: 5000 });
                            return;
                        }
                    }
                    this.$toast.add({ severity: 'error', summary: 'Ops!', detail: error.message, life: 5000 });
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
    }
}
</script>

<style>
    .contrato-tab-principal .p-tabpanels {
        padding: 0;
    }
    .contrato-tab-principal .p-scrollpanel {
        padding: var(--p-tabs-tabpanel-padding);
    }
    .contrato-tab-principal .p-scrollpanel .p-scrollpanel-bar {
        pointer-events: none;
    }
    .contrato-tab-principal .p-scrollpanel:hover .p-scrollpanel-bar {
        pointer-events: auto;
    }
</style>
